<template>
  <div class="home-first-screen">
    <v-nav>
      <a-row type="flex" align="middle" justify="space-between">
        <a-col flex="30%">
          <div class="home-description">
            <div style="width: 100%">
<!--              <img src="../assets/onlyLogo.png" style="width: 80px;display: inline-block;vertical-align: middle">-->
<!--              <div style="display: inline-block;vertical-align: middle;margin-left: 10px">-->
<!--                人脑功能图谱可视化-->
<!--                <div class="sub-title">Visualizing the functional mapping of human brain</div>-->
<!--              </div>-->
              <img src="../assets/newLogo.png" height="120" style="margin-left: -10px"/>
            </div>
            <div style="width: 500px;margin-top: 0px" class="cibr_home">
              <!--        <a-button class="main-btn" type="primary" shape="round" size="large" @click="gotoPage('/standard/surface')">标准脑</a-button>-->
              <a-dropdown-button type="primary" class="main-btn">
                {{ $t("standardBrain") }}
                <template #overlay>
                  <a-menu class="home-menu" theme="dark">
                    <a-menu-item key="surface" @click="gotoPage('/standard/surface')">
                      {{ $t("motorFunctionMapping") }}
                    </a-menu-item>
                    <a-menu-item key="language" @click="gotoPage('/standard/language')">
                      {{ $t("languageFunctionMapping") }}
                    </a-menu-item>
                    <a-menu-item key="fibre" @click="gotoPage('/standard/fibre')">
                      {{ $t("fibreBundleMapping") }}
                    </a-menu-item>
                    <a-menu-item key="statistic" @click="gotoPage('/statistic')">
                      {{ $t("dataAndStatistics") }}
                    </a-menu-item>
                  </a-menu>
                </template>
                <template #icon>
                  <DownOutlined/>
                </template>
              </a-dropdown-button>

              <a-dropdown-button type="primary" class="main-btn">
                {{ $t("personalBrain") }}
                <template #overlay>
                  <a-menu class="home-menu" theme="dark">
                    <a-menu-item key="electrical" @click="gotoPage('/personal/electrical')">
                      {{ $t("electricalPosition") }}
                    </a-menu-item>
                    <a-menu-item key="personalFibre" @click="gotoPage('/personal/fibre')">
                      {{ $t("fibreTrack") }}
                    </a-menu-item>
                  </a-menu>
                </template>
                <template #icon>
                  <DownOutlined/>
                </template>
              </a-dropdown-button>
              <!--        <a-button class="main-btn" type="primary" shape="round" size="large" @click="gotoPage('/standard/surface')">个体脑</a-button>-->
            </div>
            <p style="font-weight: normal;font-size: 14px;margin-top: 30px;text-indent:2em;word-break: break-all">
              {{ $t("homeDescription") }}
            </p>
          </div>
        </a-col>
        <a-col :flex="5">
          <div class="brain-container">
            <poly-data-show :rotation="true"></poly-data-show>
          </div>
        </a-col>
      </a-row>
      <div class="home-footer">
        <img class="logo-img" @click="gotoWebsite('https://www.bjni.org.cn/')" src="../assets/logo/sjyjs.png"/>
        <img class="logo-img" @click="gotoWebsite('http://bjtth.54doctor.net/')" src="../assets/logo/ttyy.png"/>
        <img class="logo-img" @click="gotoWebsite('https://www.cibr.ac.cn/')" src="../assets/logo/cibr.png"/>
      </div>
    </v-nav>
  </div>
</template>

<script>
import PolyDataShow from "@/components/polyDataShow";
import VNav from "@/components/public/VNav";
import {DownOutlined} from '@ant-design/icons-vue';

export default {
  name: "humanHome",
  components: {VNav, PolyDataShow, DownOutlined},
  data() {
    return {
      selectedKeys: ["fafact"],
    }
  },
  methods: {
    gotoWebsite(url) {
      window.open(url, '_blank')
    },
    gotoPage(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style scoped>
.home-first-screen {
  width: 100%;
  height: 100vh;
}

.brain-container {
  width: 100%;
  height: 90vh;
}

.home-description {
  font-size: 2rem;
  font-weight: bold;
  color: white;
  z-index: 12;
}

.sub-title {
  font-size: 0.8rem;
  font-weight: normal;

}

.standard-brain {
  background-image: url("../assets/standard.png");
}

.personal-brain {
  background-image: url("../assets/personal.png");
}

.brain-button {
  background-repeat: no-repeat;
  background-size: contain;
  height: 100px;
  width: 100px;
  display: inline-block;
  cursor: pointer;
  font-size: 1rem;
  line-height: 100px;
  text-align: center;
}

.home-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  height: 100px;
  z-index: 10;
}

.logo-img {
  height: 100%;
  cursor: pointer;
}

.main-btn {
  margin-right: 20px;
}
</style>